// App.js
import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
//import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';//!!
import Home from "./components/HomePage/Home";
import Logreg from "./components/Login/Login";
import {Edit} from "./components/Edit/Edit";
import {useEffect, useState} from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Steps from "./components/Steps/Steps";
import Team from "./components/Admin/Team";
import TeamStepCharts from "./components/Charts/Charts";
import TeamStepСumulativeCharts from "./components/Charts/СumulativeCharts/СumulativeChart";
import GameProcess from "./components/Admin/GameProcess/GameProcess";
import Games from "./components/Games/Games";
import axios from 'axios';
import Cookies from 'js-cookie';
import Logout from './components/Logout/Logout';

// Константа сервера (читаем из переменных окружения) cd ./react-app/ && REACT_APP_SERVER_URL=$(PROD_SERVER_URL) npm run build
const SERVER_IP = process.env.REACT_APP_SERVER_URL || "http://localhost:8082/api";

const ProtectedRoute = ({ children, isAuthenticated }) => {
  return isAuthenticated ? children : <Navigate to="/" replace />;
};
const ProtectedAdminRoute = ({ children, isAuthenticated, isAdmin }) => {
    if (!isAuthenticated) return <Navigate to="/" replace />;
    if (!isAdmin) return <Navigate to="/home" replace />;
    return children;
  };



function App() {

    const ServerIP = SERVER_IP;//'http://localhost:8082/api'//'/api'//'http://change.lfskills.ru:8082'//'http://127.0.0.1:8085';//  

    const [options, setOptions] = useState([]);
    const [initialData, setInitialData] = useState([]);
    const [data, setData] = useState(initialData);
    const [stepsData, setStepsData] = useState([]);
    const [currentStep, setCurrentStep] = useState(1);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);

    useEffect(() => {
        
        AOS.init({
            duration: 1000,
            once: true,
        });
        
        // Проверка аутентификации при загрузке
        const token = localStorage.getItem('authToken');
        const adminStatus = localStorage.getItem('isAdmin') === 'true';
        setIsAuthenticated(!!token);
        setIsAdmin(adminStatus); // Добавлена инициализация isAdmin


       // Обработчик изменений в localStorage
       const checkAuth = () => {
            const token = localStorage.getItem('authToken');
            const adminStatus = localStorage.getItem('isAdmin') === 'true';
            console.log(localStorage.getItem('isAdmin')) // Должно быть 'true' для админов
            setIsAuthenticated(!!token);
            setIsAdmin(adminStatus);
        };

        // Слушаем события изменения хранилища
        window.addEventListener('storage', checkAuth);

        // Добавляем интерцептор запросов
        const requestInterceptor = axios.interceptors.request.use(config => {
            const token = localStorage.getItem('authToken');
            if (token) {
                config.headers.Authorization = `Bearer ${token}`;
            }
            return config;
        });

        // Добавляем интерцептор ответов
        const responseInterceptor = axios.interceptors.response.use(
            response => response,
            error => {
            
                if (error.response?.status === 401) {
                    handleLogout();
                }
                return Promise.reject(error);
            }
        );

        return () => {
            axios.interceptors.request.eject(requestInterceptor);
            axios.interceptors.response.eject(responseInterceptor);
        };
    }, []);

    const handleLogout = () => {
        localStorage.removeItem('isAdmin');
        setIsAdmin(false);

        localStorage.removeItem('authToken');
        Cookies.remove('team_id', { path: '/' }); // path должен совпадать с установкой
        Cookies.remove('selectedGame', { path: '/' });
        setIsAuthenticated(false);
    };

    const handleLogin = (userData) => {
        /*setIsAuthenticated(true);
        setIsAdmin(userData.is_admin);
        //localStorage.setItem('isAdmin', userData.is_admin);*/
        setIsAuthenticated(true);
  
        // Безопасное извлечение статуса администратора
        const adminStatus = Boolean(userData?.is_admin);
        setIsAdmin(adminStatus);
        
        // Сохраняем все данные
        localStorage.setItem('authToken', userData.token);
        localStorage.setItem('isAdmin', adminStatus.toString());
        Cookies.set('team_id', userData.teamID, { expires: 7 });
    };

    return (
        <Router>
            <div className="root-scale">
                <Routes>
                    <Route 
                        path="/" 
                        element={
                            isAuthenticated ? (
                                <Navigate to="/home" replace />
                            ) : (
                                <Logreg 
                                    onLogin={handleLogin} 
                                    serverIP={ServerIP}
                                />
                            )
                        } 
                    />
                    <Route path="/logout" element={<Logout />} />
                    <Route 
                        path="/home" 
                        element={
                                <ProtectedRoute isAuthenticated={isAuthenticated}>
                                    <Home 
                                        isAdmin={isAdmin}
                                        options={options}  
                                        setStepsData={setStepsData}   
                                        onSend={(stepNumber, stepData) => setStepsData((prev) => ({...prev, [stepNumber]: stepData}))} 
                                        setOptions={setOptions} 
                                        initialData={initialData}  
                                        currentStep={currentStep} 
                                        setCurrentStep={setCurrentStep} 
                                        data={data} 
                                        setData={setData}
                                        serverIP={ServerIP}
                                    />
                                </ProtectedRoute>
                        } 
                    />

                    <Route path="/steps" 
                        element={
                            <ProtectedRoute isAuthenticated={isAuthenticated}>
                                <Steps 
                                    isAdmin={isAdmin} 
                                    serverIP={ServerIP} />
                            </ProtectedRoute>    
                        } 
                    />
                     <Route path="/Team"
                        element={
                            <ProtectedAdminRoute isAuthenticated={isAuthenticated} isAdmin={isAdmin}>
                                <Team 
                                    isAdmin={isAdmin} 
                                    serverIP={ServerIP}
                                />
                            </ProtectedAdminRoute>    
                        } 
                    />
                    <Route path="/Charts"
                        element={
                            <ProtectedAdminRoute isAuthenticated={isAuthenticated} isAdmin={isAdmin}>
                                <TeamStepCharts 
                                    isAdmin={isAdmin}
                                    serverIP={ServerIP}
                                />
                            </ProtectedAdminRoute>    
                        } 
                    />
                    <Route path="/СumulativeCharts"
                        element={
                            <ProtectedAdminRoute isAuthenticated={isAuthenticated} isAdmin={isAdmin}>
                                <TeamStepСumulativeCharts 
                                    isAdmin={isAdmin}
                                    serverIP={ServerIP}
                                />
                            </ProtectedAdminRoute>    
                        } 
                    />
                    <Route path="/GameProcess"
                        element={
                            <ProtectedAdminRoute isAuthenticated={isAuthenticated} isAdmin={isAdmin}>
                                <GameProcess 
                                    isAdmin={isAdmin}
                                    serverIP={ServerIP}
                                />
                            </ProtectedAdminRoute>    
                        } 
                    />                     
                     {/*<Route path="/Games"
                        element={
                            <ProtectedAdminRoute isAuthenticated={isAuthenticated} isAdmin={isAdmin}>
                                <Games isAdmin={isAdmin}/>
                            </ProtectedAdminRoute>    
                        } 
                    />*/}
                    {/* Остальные защищенные маршруты */}                    
                    {/*<Route path="/additional" element={<Admin />} />*/}
                    {/*<Route path="/edit" element={<Edit options={options} setOptions={setOptions}/>} />*/}
                </Routes>
            </div>
        </Router>
    );
}

export default App;